import { Box, Link, Typography } from '@mui/material';
import { t } from 'i18next';
import OpenFolderIcon from '../../../../assets/images/open-folder.svg';
import { SEVERITY_COLORS } from '../../../../common/enums/Severity';
import { UrlHelper } from '../../../../common/utils/UrlHelper';
import { stopPropagationHandler } from '../../../../common/utils/handlers';
import { PriorityFix } from '../../models/PriorityFix';

type Props = {
  fix: PriorityFix;
};

export const PriorityFixCard = ({ fix }: Props) => {
  const projectId = fix.getProject()?.getId();
  const projectName = fix.getProject()?.getName() ?? '';
  const projectUrl = projectId
    ? UrlHelper.generateProjectDashboardUrl(projectId, {
        displaySeverity: fix.getSeverity(),
        focusToIssueNumber: fix.getNumber(),
      })
    : null;

  return (
    <Box
      data-role="priority-fix-card"
      sx={{
        display: 'block',
        color: 'text.primary',
        // cursor: 'pointer',
        mb: 0.25,
        borderLeft: '3px solid',
        borderLeftColor: SEVERITY_COLORS[fix.getSeverity()].main,
        '&:not(:first-of-type)': {
          borderTop: `1px solid`,
          borderTopColor: 'grey.300',
        },
        px: 2,
        py: 1,
        transition: 'all 0.3s ease-in-out',
      }}
    >
      {projectUrl && (
        <Link
          href={projectUrl}
          onClick={stopPropagationHandler}
          aria-label={
            t('a11y.organization.dashboard.navigateToIssueForProject', {
              projectId: projectId,
              projectName: projectName,
              issueNumber: fix.getNumber(),
              issueName: fix.getName(),
            }) as string
          }
        >
          <OpenFolderIcon aria-hidden="true" />
          <Typography
            variant="caption"
            sx={{
              verticalAlign: 'bottom',
              ml: 1,
            }}
          >
            {projectName}
          </Typography>
        </Link>
      )}
      <Typography variant="button" sx={{ display: 'block', fontWeight: 400 }}>
        <span style={{ fontWeight: 600 }}>{`${fix.getNumber()}. `}</span>
        {fix.getName()}
      </Typography>
      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        {fix.getDescription()}
      </Typography>
    </Box>
  );
};
